module.exports = __webpack_public_path__ + "img/av-cyr.2efd67b3.png";